// ScrollBar.tsx
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./scrollBar.css";

export const ScrollBar: React.FC = () => {
  const { i18n } = useTranslation(); // i18n object
  const [scrollPercentage, setScrollPercentage] = useState(0);

  const handleScroll = () => {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrolled = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    setScrollPercentage(scrolled);
  };

  useEffect(() => {
    // Recalculate scroll on scroll
    window.addEventListener("scroll", handleScroll);

    // Recalculate scroll on language change
    const timeout = setTimeout(() => handleScroll(), 50); // small delay to wait for layout reflow

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timeout);
    };
  }, []);

  // Recalc scroll whenever language changes
  useEffect(() => {
    const timeout = setTimeout(() => handleScroll(), 50);
    return () => clearTimeout(timeout);
  }, [i18n.language]);

  return (
    <div className="progress-bar-container">
      <div
        className="progress-bar"
        style={{ width: `${scrollPercentage}%` }}
      />
    </div>
  );
};

export default ScrollBar;
